import {ScrollTrigger, gsap} from "../LibrariesImport";

export default class BlockTimeline {
    static init() {
        document.querySelectorAll(".block-timeline").forEach(block => {
            const pin = block.querySelector(".current-year-pin");
            const currentYearDisplay = block.querySelector(".current-year");
            const timeline = block.querySelector(".timeline");

            // Pin the current year indicator
            ScrollTrigger.create({
                trigger: timeline,
                start: "top center",
                end: () => `+=${timeline.clientHeight - timeline.clientHeight / 35}`,
                scrub: true,
                pin: pin,
                pinType:"transform",
                anticipatePin: 1,
            });

            // Iterate through all timeline items (months)
            block.querySelectorAll(".timeline-item").forEach((timelineItem, index) => {

                const bigYear = timelineItem.querySelector(".year-big");
                gsap.set(bigYear, {opacity: 0});
                const odd = timelineItem.classList.contains("odd");
                const xOffset = odd ? "15px" : "-15px";

                ScrollTrigger.create({
                    trigger: timelineItem,
                    start: "top center",
                    end: "bottom center",
                    onEnter: () => {
                        gsap.to(bigYear, {opacity: 1});
                        gsap.from(bigYear, {x: xOffset});
						currentYearDisplay.innerHTML = bigYear.innerHTML;
                    },
                    onEnterBack: () => {
                        gsap.to(bigYear, {opacity: 1});
                        gsap.from(bigYear, {x: xOffset});
						currentYearDisplay.innerHTML = bigYear.innerHTML;
                    },
                    onLeave: () => {
                        gsap.to(bigYear, {opacity: 0});
                    },
                    onLeaveBack: () => {
                        gsap.to(bigYear, {opacity: 0});
                    }
                });
            });

            /**
             * Updates and animates the year and month when entering a timeline item.
             * @param {string} yearText - The text for the year.
             * @param {string} monthText - The text for the month.
             * @param {string} xOffset - The horizontal offset for animation.
             */
            function updateYearAndAnimate(yearBigDisplay, monthText, xOffset) {
                // Update the current year and animate the big year
                if (currentYearDisplay.textContent !== yearBigDisplay.textContent) {
                    currentYearDisplay.textContent = yearBigDisplay.textContent;
                    gsap.fromTo(
                        yearBigDisplay,
                        {opacity: 0, x: xOffset},
                        {opacity: 1, x: "0px", duration: 0.5}
                    );
                }
            }

            /**
             * Hides the big year display with an animation.
             */
            function hideBigYear(yearBigDisplay) {
                gsap.to(yearBigDisplay, {opacity: 0, duration: 0.5});
            }
        });
    }
}
